export default __webpack_public_path__ + "static/illu_student1-e9fd08b42952791f65b15ae0a1163e80.jpg";